import {TimeQueueItem} from "./TimeQueueItem";
import {ISendQueueEntry} from "./ISendQueueEntry";
import {IAppUser, IEmployeeVm, ILoginViewModel, IMobileUser, ITimeEntryTypeVm} from '../Data/Data';

export class StorageService {

  static serviceId = "storage";
  static $inject = [];

  private loginKey = "LOGIN";
  private appUserKey = "APP_USER";
  private locationIdKey = "LOCATION_ID";
  private latestEntryMapKey = "LATEST_ENTRIES";
  private entriesKey = 'TIME_ENTRIES';
  private timeEntryTypesKey = 'TIME_ENTRY_TYPES';
  private employeeKey = 'EMPLOYEES';
  private tokenKey = 'APP-TOKEN';
  private timeStampPrefix = 'last_update_';

  constructor() {

  }

  clearServerSpecificData() {
    this.setEntryQueue(null);
    this.setAppUser(null);
    this.setLocationId(null);
    this.setLatestEntryMap(null);
    this.setTimeEntryTypes(null);
    this.setEmployees(null);
  }

  hasTimeEntryTypes() {
    return this.has(this.timeEntryTypesKey);
  }

  setTimeEntryTypes(timeEntries: ITimeEntryTypeVm[]) {
    this.set(timeEntries, this.timeEntryTypesKey);
  }

  setEmployees(emp) {
    this.set(emp,  this.employeeKey);

    const stamp = emp !== null ? new Date().getTime() : null;

    this.set(stamp, this.timeStampPrefix + this.employeeKey);

  }

  getEmployees() {
    return this.retrieve<IEmployeeVm[]>(this.employeeKey);
  }

  getLasEmployeeUpdate() {
    return this.retrieve<number>(this.timeStampPrefix + this.employeeKey);
  }

  getTimeEntryTypes() {
    return this.retrieve<ITimeEntryTypeVm[]>(this.timeEntryTypesKey);
  }

  getLatestEntryMap = () => {
    return this.retrieve<{ [key: string]: TimeQueueItem }>(this.latestEntryMapKey);
  };

  setLatestEntryMap = (map : {[key:string] :TimeQueueItem}) => {
    this.set(map, this.latestEntryMapKey);
  };

  setLocationId = (locationId) => {
    this.set(locationId, this.locationIdKey);
  };

  getCachedAppUser = () => {
    return this.retrieve<IMobileUser>(this.appUserKey);
  };

  setAppUser = (data: IMobileUser) => {
    this.set(data, this.appUserKey);
  };

  getLoginData = () => {
    return this.retrieve<ILoginViewModel>(this.loginKey);
  };

  clearLoginData() {
    this.clear(this.loginKey);
  }

  setLoginData = (login: ILoginViewModel) => {
    this.set(login, this.loginKey);
  };

  getEntryQueue = () => {
    return this.retrieve<ISendQueueEntry[]>(this.entriesKey);
  };

  setEntryQueue = (entries: ISendQueueEntry[]) => {
    this.set(entries, this.entriesKey);
  };

  setToken(token: string) {
    this.set(token, this.tokenKey);
  }

  getToken() {
    return this.retrieve<string>(this.tokenKey);
  }

  private clear(key: string) {
    localStorage.removeItem(key);
  }

  private retrieve<TType>(key: string) {
    const data = localStorage.getItem(key);
    if (data == null)
      return null;

    return <TType> JSON.parse(data);
  }

  private set<TType>(data: TType, key: string) {
    let dataString;
    if (data) {
      dataString = JSON.stringify(data);
    } else {
      dataString = null;
    }
    localStorage.setItem(key, dataString);
  }

  private has(key: string) {
    const data = JSON.parse(localStorage.getItem(key));
    return data !== null && data !== undefined;
  }
}